module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


//////////////////
// WEBPACK FOOTER
// /app/~/core-js/library/modules/_is-object.js
// module id = ../../../../core-js/library/modules/_is-object.js
// module chunks = 7